export default ({}) => {
    return (
        <div className="account-aufa-cash">
            <p>יש להעביר את המזומן למשרד תוך 24 שעות, לאחר מכן ההזמה תיפול</p>
        </div>
    )
}